import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Container from '../components/Container';
import Button from '../components/Button';
import SEO from '../lib/seo';

/**
 * 404 Not Found page component
 * @returns {React.ReactElement} NotFound page
 */
const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Page Not Found | Lone Star Aerial Solutions"
        description="The page you're looking for doesn't exist."
        url="/404"
      />
      
      <Header />
      
      <main className="flex-grow flex items-center">
        <Container className="py-20 md:py-32 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">404</h1>
          <h2 className="text-2xl md:text-3xl font-bold mb-6">Page Not Found</h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto">
            The page you're looking for doesn't exist or has been moved.
            Let's get you back on track.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button as={Link} to="/">
              Return to Home
            </Button>
            <Button as={Link} to="/contact" variant="secondary">
              Contact Us
            </Button>
          </div>
        </Container>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFound;
